import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTransactionData } from "../../hooks/useTransactionData";
import { Box } from "react-bulma-components";
import { Pagination } from "react-bulma-components";
import { Heading } from "react-bulma-components";
import { Table } from "react-bulma-components";
import {getDataFresh, getTransactionData} from "../../state/selectors";
import Spinner from "react-spinner-material";
import { Button } from "react-bulma-components";
import axios from "axios";
import {createSetDataFreshAction, createSetTransactionDataAction} from "../../actions/dataActions";
import { getWeeklyTransactionData } from "../../state/selectors";
import Collapsible from "react-collapsible";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";
import WeeklyTransactionRow from "./WeeklyTransactionRow";
import {fixEmptyDatesNotJob} from "../../utils";

function WeeklyTransactionView({endpoint, type}) {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({});
  const dateFields = ["invoice_date", "payment_date", "date"];
  const typeMapping = {
    'IN': 'Income',
    'OUT': 'Expense'
  };

  const [page, setPage] = useState(1);
  let params = {
      view: "repeating",
      page,
      type
    }

  for (let filter in filters) {
    if (filters[filter][0] && filters[filter][0][filter]) {
      params[filter] = filters[filter][0][filter];
    }
  }
  const dataFresh = useSelector(getDataFresh);
  const complete = useTransactionData(
    params,
    dataFresh
  );

  const submitUpdate = (approval, transaction) => {
    transaction.approved = !!approval;
    const url = endpoint + "transactions/update/" + transaction.id;
    const data = fixEmptyDatesNotJob(transaction, dateFields);
    const conf = {
      method: "put",
      data,
      url
    };

    return axios(conf)
  };

  const onTransactionUpdate = (index, newTransaction) => {
    let newState = {...data};
    newState.results[index] = newTransaction;
    console.log(newState)
    dispatch(createSetTransactionDataAction(newState));
  };

  const handleDelete = id => {
    const endpoint = "/api/transactions/" + id;
    const conf = { method: "delete", url: endpoint };
    axios(conf).then(response =>
      dispatch(createSetDataFreshAction(dataFresh + 1))
    );
  };

  const headings = [
      {
          label: "Description"
      },
      {
          label: "Frequency"
      },
      {
          label: "Contact"
      },
      {
          label: "Department",
          field: "department",
          labelField: "department__name"
      },
      {
          label: "Type"
      },
      {
          label: "Comments"
      },
      {
          label: "Remove From Figures"
      },
      {
          label: "Amount"
      }
  ]

  const data = useSelector(getWeeklyTransactionData);
  if (!complete) {
    return (
      <Box>
        <Spinner
          className="spinner-centre"
          size={120}
          spinnerColor={"#3273dc"}
          spinnerWidth={2}
        />
      </Box>
    );
  }

  return (
    <Box>
      <Collapsible
        className="title"
        triggerOpenedClassName="title"
        trigger="Repeating Transactions"
      >
      <Table>
        <thead>
          <tr className="small-row-black">
              {headings.map(heading => {
                if (!heading.field) {
                  return <th key={heading.label}>{heading.label}</th>;
                }
                if (heading.blank) {
                  return (
                    <FilterBlankHeading
                      key={heading.label}
                      heading={heading}
                      setFilters={f => {
                        setPage(1);
                        setFilters(f);
                      }}
                      filters={filters}
                    />
                  );
                }
                return (
                  <FilterHeading
                    key={heading.label}
                    heading={heading}
                    setFilters={f => {
                      setPage(1);
                      setFilters(f);
                    }}
                    filters={filters}
                    options={data.filter_list[heading.field]}
                  />
                );
              })}
              <th></th>
              <th></th>
          </tr>
        </thead>
        <tbody>
          {data.results.map((value,index) => (
            <WeeklyTransactionRow
                value={value}
                typeMapping={typeMapping}
                onDelete={handleDelete}
                onSave={submitUpdate}
                onChange={onTransactionUpdate}
                index={index}
            />
          ))}
        </tbody>
      </Table>
      <Pagination
        showFirstLast={true}
        onChange={page => setPage(page)}
        current={page}
        total={Math.ceil(data.count / 25)}
      >
        {" "}
      </Pagination>
      </Collapsible>
    </Box>
  );
}

export default WeeklyTransactionView;
